/* eslint-disable */
import _ from 'underscore';

export const getAdsLabelStyles = ({ styleOverrides }) => (e, { palette = {} }) => {
  return {
    adsLabel: _.extend({
      color: palette.black,
      margin: 7,
      opacity: '90%',
      padding: '1.2px 6px 1.8px 6px',
      position: 'absolute',
      fontSize: 11,
      borderRadius: 5,
      backgroundColor: palette.white,
      whiteSpace: 'nowrap',
    }, styleOverrides.adsLabel),
  };
};
